import { appConfig } from "@/lib/constants";
import Image from "next/image";

export function Logo() {
  return (
    <Image
      src="/logo.svg"
      alt={appConfig.companyName}
      width={228}
      height={22}
    />
  );
}
